import { render, staticRenderFns } from "./subtask-item.vue?vue&type=template&id=f68bd102&scoped=true&"
import script from "./subtask-item.vue?vue&type=script&lang=js&"
export * from "./subtask-item.vue?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&id=f68bd102&prod&lang=scss&scoped=true&"
import style1 from "./subtask-item.vue?vue&type=style&index=1&id=f68bd102&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68bd102",
  null
  
)

export default component.exports